import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [laden, setLaden] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLaden(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLaden(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#2B231D] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-[#352B24] rounded-3xl border border-[#483B32] shadow-2xl p-8 sm:p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src="/assets/logo.jpg" alt="De Houtregisseur logo" className="w-12 h-12 rounded-lg object-cover border border-[#4F4137]" />
          <div>
            <span className="block text-base font-bold text-white font-display">DE HOUTREGISSEUR</span>
            <span className="block text-[10px] tracking-widest uppercase font-semibold text-[#8C7A6B]">Beheeromgeving</span>
          </div>
        </div>

        <h1 className="text-2xl font-display text-white mb-6">Inloggen als beheerder</h1>

        <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="block text-xs font-medium text-[#D8CFC4] mb-2">E-mailadres</label>
            <input
              id="admin-email"
              type="email"
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-xl bg-[#231C17] border border-[#4F4137] text-white placeholder-[#7A6C60] focus:outline-none focus:border-[#E6AF68] text-sm"
              placeholder="admin@dehoutregisseur.nl"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-xs font-medium text-[#D8CFC4] mb-2">Wachtwoord</label>
            <input
              id="admin-password"
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-xl bg-[#231C17] border border-[#4F4137] text-white placeholder-[#7A6C60] focus:outline-none focus:border-[#E6AF68] text-sm"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="text-sm text-[#F0A08A] bg-[#4A2C22] border border-[#6B4034] rounded-xl px-4 py-3">
              {error}
            </p>
          )}

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={laden}
            className="w-full inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-[#E6AF68] text-[#1C1612] font-bold text-sm hover:bg-[#F0C287] transition-colors shadow-md disabled:opacity-60"
          >
            {laden && <Loader2 size={16} className="animate-spin" />}
            Inloggen
          </button>
        </form>

        <a href="/" data-testid="admin-login-terug" className="block text-center text-xs text-[#A89C8F] hover:text-white transition-colors mt-6">
          ← Terug naar de website
        </a>
      </div>
    </div>
  );
}
